module.exports = __webpack_public_path__ + "img/drag-and-drop.20b79550.svg";